import Vue from 'vue'
import Router from 'vue-router'
import IndexPage from '@/class/IndexPage'

// import Sidebar from '@/components/Sidebar'
import login from '@/login/login'
import register from '@/login/register'

import rePassword from '@/login/rePassword'
import course from '@/class/course'
import courseDetail from '@/class/courseDetail'

import booking from '@/order/booking'
import student from '@/order/student'
import pay from '@/order/pay'

import succeed from '@/order/succeed'
import order from '@/order/order'
import orderDetail from '@/order/orderDetail'

import mine from '@/mine/mine'
import studentsInfo from '@/mine/studentsInfo'
import addStudents from '@/mine/addStudents'

import changeStudents from '@/order/changeStudents'
import personal from '@/mine/personal'
import modification from '@/mine/modification'

import registration from '@/mine/registration'
import binding from '@/mine/binding'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/rePassword',
      name: 'rePassword',
      component: rePassword
    },
    {
      path: '/',
      name: 'IndexPage',
      component: IndexPage
    },
    {
      path: '/course',
      name: 'course',
      component: course
    },
    {
      path: '/courseDetail',
      name: 'courseDetail',
      component: courseDetail
    },
    {
      path: '/booking',
      name: 'booking',
      meta: {
        requireAuth: true
      },
      component: booking
    },
    {
      path: '/student',
      name: 'student',
      meta: {
        requireAuth: true
      },
      component: student
    },
    {
      path: '/pay',
      name: 'pay',
      meta: {
        requireAuth: true
      },
      component: pay
    },
    {
      path: '/succeed',
      name: 'succeed',
      meta: {
        requireAuth: true
      },
      component: succeed
    },
    {
      path: '/order',
      name: 'order',
      meta: {
        requireAuth: true
      },
      component: order
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      meta: {
        requireAuth: true
      },
      component: orderDetail
    },
    {
      path: '/mine',
      name: 'mine',
      meta: {
        requireAuth: true
      },
      component: mine
    },
    {
      path: '/studentsInfo',
      name: 'studentsInfo',
      meta: {
        requireAuth: true
      },
      component: studentsInfo
    },
    {
      path: '/addStudents',
      name: 'addStudents',
      meta: {
        requireAuth: true
      },
      component: addStudents
    },
    {
      path: '/changeStudents',
      name: 'changeStudents',
      meta: {
        requireAuth: true
      },
      component: changeStudents
    },
    {
      path: '/personal',
      name: 'personal',
      meta: {
        requireAuth: true
      },
      component: personal
    },
    {
      path: '/modification',
      name: 'modification',
      meta: {
        requireAuth: true
      },
      component: modification
    },
    {
      path: '/registration',
      name: 'registration',
      meta: {
        requireAuth: true
      },
      component: registration
    },
    {
      path: '/binding',
      name: 'binding',
      meta: {
        requireAuth: true
      },
      component: binding
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!localStorage.getItem('token')) {
      next({
        name: 'login'
      })
    } else {
      next()
    }
  } else {
    next() // 确保一定要调用 next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js